export function getProvinciaTaris (codigo) {
    var numeroPostal=codigo;
    var expresionRegular1=/^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/;//<--- con esto vamos a validar el numero
    var expresionRegular2=/\s/;//<--- con esto vamos a validar que no tenga espacios en blanco
    var provincias =["ARABA/ALAVA", "Albacete", "Alicante", "Almeria", "Avila", "Badajoz", "Baleares", "Barcelona", "Burgos", "Caceres", "Cadiz", "Castellon", "Ciudad Real", "Cordoba", "Coruña", "Cuenca", "Gerona", "Granada", "Guadalajara", "Guipuzcoa", "Huelva", "Huesca", "Jaen", "Leon", "Lerida", "La Rioja", "Lugo", "Madrid", "Malaga", "Murcia", "Navarra", "Orense", "Asturias", "Palencia", "Las Palmas", "Pontevedra", "Salamanca", "Santa Cruz De Tenerife", "Cantabria", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "BIZKAIA", "Zamora", "Zaragoza", "Ceuta", "Melilla"]

    if(numeroPostal === ''){
    } else if(expresionRegular2.test(numeroPostal)){
         return false;
    } else if(!expresionRegular1.test(numeroPostal)){
        return false;
    } else{
        var codigoProvincia =  parseInt(numeroPostal.substring(0,2)) - 1;
        if (codigoProvincia < 52){
             return provincias[codigoProvincia];
        } else{
            return false; 
        }
    }   
}